import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, HostListener } from '@angular/core';
import { ConverterService, I18nModule, LoggerService, Product, RoutingService, StateWithProduct } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { FocusConfig, ICON_TYPE, IconModule, KeyboardFocusModule, LaunchDialogService, SearchBoxComponentService } from "@spartacus/storefront";
import { GenProductService } from 'src/app/generac/services/product.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { GenSearchBoxComponent } from '../search-box.component';

const SP_SEARCH_CRITERIAS = [{
  name: 'Model',
  value: 'model',
}, {
  name: 'Serial Number',
  value: 'serial-number',
}];


@Component({
  selector: 'gen-service-parts-search-dialog',
  templateUrl: './service-parts-search-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    KeyboardFocusModule,
    GenSearchBoxComponent,
  ]
})
export class GenServicePartsSearchDialogComponent {
  private subscriptions = new Subscription();

  readonly iconTypes = ICON_TYPE;
  readonly SP_SEARCH_CRITERIAS = SP_SEARCH_CRITERIAS;
  readonly focusConfig: FocusConfig = {
    trap: true,
    block: true,
    autofocus: 'button',
    focusOnEscape: true,
  };

  activeSpSearchCriteria: string = SP_SEARCH_CRITERIAS[0].value;
  selectedSpSearchProduct: Product;

  @HostListener('click', ['$event'])
  handleClick(event: UIEvent): void {
    // Close on click outside the dialog window
    if ((event.target as any).tagName === this.el.nativeElement.tagName) {
      this.closeDialog('Cross click');
    }
  }

  constructor(
    protected launchDialogService: LaunchDialogService,
    protected el: ElementRef,
    protected productService: GenProductService,
    protected converter: ConverterService,
    protected router: Router,
    protected store: Store<StateWithProduct>,
    protected searchBoxComponentService: SearchBoxComponentService,
    protected logger: LoggerService,
    protected routingService: RoutingService,
  ) { }

  selectSpSeachTab(tab: string): void {
    this.activeSpSearchCriteria = tab;
  }

  selectSpSearchProduct(product: Product): void {
    this.selectedSpSearchProduct = product;
  }

  navigateToSpSearch(): void {
    this.routingService.go(`/search/`, {
      queryParams: {
        searchBy: this.selectedSpSearchProduct?.code && this.activeSpSearchCriteria,
        code: this.selectedSpSearchProduct?.code,
        query: `:relevance:servicePart:true`
      }
    });
    this.closeDialog('navigate to search');
  }

  closeDialog(reason: string): void {
    this.searchBoxComponentService.clearResults();
    this.launchDialogService.closeDialog(reason);
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
    this.closeDialog('close dialog');
  }
}
